<template>
  <form @submit.prevent>
    <div class="row">
      <div class="col-12">
        <fg-input type="text"
          placeholder="Version"
          :class="{ 'form-group--error': $v.name.$error }"
          v-model="$v.name.$model">
        </fg-input>
      </div>
    </div>
    <div class="row mb-2">
      <div class="col-12">
        <div class="form-group form-check">
          <toggle-button
            class="form-check-input"
            :labels="{checked: 'Active', unchecked: 'Inactive'}"
            :width="67"
            v-model="isActive"
            :color="{checked: '#229863', unchecked: '#CB3247'}" />
        </div>
      </div>
    </div>
    <div class="text-left">
      <p-button type="info"
        :loading="isSaving"
        @click.native.prevent="saveVersion">
        <span v-if="!version">Create</span>
        <span v-else>Save</span>
      </p-button>
    </div>
    <div class="clearfix"></div>
  </form>
</template>

<script>
import { notify } from '../../services/notify';
import { required } from 'vuelidate/lib/validators';
import { mapGetters } from 'vuex';
import ziperase from '../../services/ziperase';

export default {
  name: 'VersionForm',
  props: {
    product: Object,
    version: {
      required: false,
      type: Object
    }
  },
  data() {
    return {
      name: "",
      isActive: true,
      isSaving: false,
      addedVersions: []
    };
  },
  validations: {
    name: { required }
  },
  created() {
    if (this.version) {
      this.name = this.version.version;
      this.isActive = this.version.is_active;
    }
  },
  methods: {
    async saveVersion() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        notify().error('Please enter a version.');
        return;
      }

      let version = {
        version:    this.name,
        is_active:  this.isActive
      };

      this.isSaving = true;
      let success = false;
      if (!this.version) {
        version.product_id = this.product.id;
        success = await this.$store.dispatch('product/createVersion', version);
      } else {
        version.version_id = this.version.id;
        success = await this.$store.dispatch('product/updateVersion', version);
      }
      this.isSaving = false;

      if (success) {
        this.$emit('hasUpdate');
        if (!this.version) {
          this.resetForm();
        }
      }
    },
    resetForm() {
      this.name = "";
      this.isActive = true;
      this.$v.$reset();
    }
  }
};
</script>

<style scoped>
.license-badge {
  margin-right: 5px;
}
</style>